<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_27620_297286)">
      <path
        d="M14.6615 7.33203V11.332C14.6615 13.9987 13.9948 14.6653 11.3281 14.6653H4.66145C1.99479 14.6653 1.32812 13.9987 1.32812 11.332V4.66536C1.32812 1.99869 1.99479 1.33203 4.66145 1.33203H5.66146C6.66146 1.33203 6.88145 1.62536 7.26145 2.13203L8.26145 3.46536C8.51479 3.79869 8.66145 3.99869 9.32812 3.99869H11.3281C13.9948 3.99869 14.6615 4.66536 14.6615 7.33203Z"
        :stroke="color"
        stroke-miterlimit="10"
      />
      <path
        d="M14.6615 6.66536H11.9948C9.99479 6.66536 9.32812 5.99869 9.32812 3.99869V1.33203L14.6615 6.66536Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.67188 8.66797H8.67187"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.67188 11.332H7.33854"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_27620_297286">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  color: {
    type: String,
    default: "black",
  },
});
</script>
